import React, { useEffect, useState } from 'react'
import { Box, TextField, Button } from '@mui/material'
import { useMutation } from '@apollo/react-hooks'
import gql from 'graphql-tag'
import { useAuthentication } from '../hooks/useAuthentication'

const SIGNIN_MANUAL = gql`
  mutation authManual($input: LoginInput!) {
    signIn(input: $input) {
      token
      user {
        first_name
        last_name
        email
        branch
        user_role {
          id
          name
        }
        site_admin
        user_role {
          id
          name
        }
        site_admin
        department {
          id
          name
        }
      }
    }
  }
`

const LoginForm = () => {
  const { signIn } = useAuthentication()
  const [authManual, manualAuthResp] = useMutation(SIGNIN_MANUAL)
  const [user, setUser] = useState({ email: '', password: '' })

  useEffect(() => {
    if (manualAuthResp.data?.signIn?.token) {
      signIn(manualAuthResp.data.signIn.token)
    }
  }, [manualAuthResp.data, signIn])

  if (manualAuthResp.loading) return <p>Loading...</p>
  if (manualAuthResp.error) {
    console.error(manualAuthResp.error)
    return <p>ERROR occurred</p>
  }

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    if (user.email !== '' && user.password !== '') {
      authManual({
        variables: { input: { email: user.email, password: user.password } },
      })
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        id="email"
        label="Email"
        type="email"
        value={user.email}
        onChange={(e) => setUser({ ...user, email: e.currentTarget.value })}
        variant="filled"
        margin="normal"
        fullWidth
        autoFocus
        required
      />
      <TextField
        id="password"
        label="Password"
        type="password"
        value={user.password}
        onChange={(e) => setUser({ ...user, password: e.currentTarget.value })}
        variant="filled"
        margin="normal"
        fullWidth
        required
      />
      <Box display="flex" justifyContent="flex-end">
        <Button type="submit" variant="contained" size="small" color="primary">
          Sign in
        </Button>
      </Box>
    </form>
  )
}

export default LoginForm
